import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { analytics, logEvent } from "../firebase";

import {
  Container,
  Row,
  Col,
  Image,
  Card,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import "./ShopProfile.css";

const OfferShopProfile = () => {
  const [showNote, setShowNote] = useState(true);
  const location = useLocation();
  const shopId = location.state?.shopId || sessionStorage.getItem("lastShopId");
  const userEmail =
    location.state?.userEmail ||
    sessionStorage.getItem("userEmail") ||
    localStorage.getItem("userEmail");

  const [shopDetails, setShopDetails] = useState(null);
  const [vegetables, setVegetables] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedQuantities, setSelectedQuantities] = useState({});
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (shopId) {
      sessionStorage.setItem("lastShopId", shopId);
    }
    if (userEmail) {
      sessionStorage.setItem("userEmail", userEmail);
    }
  }, [shopId, userEmail]);

  const fetchShopDetails = async () => {
    try {
      const response = await fetch(
        `https://yaasaai.com/myphpapi/shopdetails.php?shopId=${encodeURIComponent(
          shopId
        )}`
      );
      const data = await response.json();
      setShopDetails(data);
    } catch (err) {
      setError("Failed to load shop details.");
    }
  };

  const fetchShopOffers = async () => {
    try {
      const response = await fetch(
        `https://yaasaai.com/myphpapi/shopoffers.php?shopId=${encodeURIComponent(
          shopId
        )}`
      );
      const data = await response.json();
      setVegetables(data);

      const initialQuantities = {};
      data.forEach((veg) => {
        initialQuantities[veg.id] = 1;
      });
      setSelectedQuantities(initialQuantities);
    } catch (err) {
      setError("Failed to load shop offers.");
    }
  };

  useEffect(() => {
    if (shopId) {
      setLoading(true);
      Promise.all([fetchShopDetails(), fetchShopOffers()])
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  }, [shopId]);

  window.gtag("event", "offer_shop_view", {
    veg_name: "view offer shop",
    phone: userEmail,
  });

  const handleQuantityChange = (vegId, quantity) => {
    setSelectedQuantities((prevQuantities) => ({
      ...prevQuantities,
      [vegId]: quantity,
    }));
  };

  const handleAddToCart = async (veg) => {
    if (!shopId || !veg.veg_name) {
      console.error("Missing shop or item details.");
      return;
    }
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const istTime = new Date(utc + 5.5 * 60 * 60000);

    // Format to "DD-MM-YYYY HH:mm"
    const pad = (n) => (n < 10 ? "0" + n : n);
    const added_date = `${pad(istTime.getDate())}-${pad(
      istTime.getMonth() + 1
    )}-${istTime.getFullYear()} ${pad(istTime.getHours())}:${pad(
      istTime.getMinutes()
    )}`;
    console.log("here is the date", added_date);

    const totalStock = parseInt(veg.offer_stock) || 0;
    const addedStock = parseInt(veg.offer_stock_added) || 0;

    if (totalStock > 0 && addedStock >= totalStock) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        title: "All slots for this offer are already filled.",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    const cartItem = {
      shop_name: shopDetails?.shop_name || "Unknown Shop",
      shop_id: shopId,
      phonenumber: userEmail || "",
      veg_name: veg.veg_name,
      veg_image_name: veg.veg_image_name,
      veg_quantity: veg.item_details,
      veg_rate: veg.total_price,
      added_date: added_date, // ⬅️ Send this to backend
    };

    // ✅ Track Add-to-Cart in GA4
    if (typeof window.gtag === "function") {
      window.gtag("event", "add_to_cart", {
        veg_name: veg.veg_name,
        quantity_label: veg.item_details,
        phone: userEmail,
        price: veg.total_price,
        shop_id: shopId,
        shop_name: shopDetails?.shop_name || "Unknown",
        is_offer_item: true,
        user_id: userEmail || "guest",
      });
    }

    try {
      const response = await fetch(
        `https://yaasaai.com/myphpapi/addtocartdebug.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartItem),
        }
      );

      const result = await response.json();
      if (response.ok) {
        console.log("Item added to cart successfully:", result);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 1000);
      } else {
        console.error("Failed to add item to cart:", result.message);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <Container fluid style={{ paddingTop: "80px" }} className="px-4">
      {showToast && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#28a745",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            zIndex: 1050,
            fontWeight: "600",
            fontSize: "0.9rem",
            pointerEvents: "none",
          }}
        >
          Item added to cart!
        </div>
      )}
      <Modal show={showNote} onHide={() => setShowNote(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Important Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            सीधी मंडी से ताज़ा माल – कम दाम, बढ़िया क्वालिटी। हम कोशिश करते हैं
            बढ़िया खरीदारी की, लेकिन 100% quality accuracy नहीं और वज़न 250–500g
            ऊपर-नीचे हो सकता है। रिटर्न नहीं, क्योंकि थोक में खरीदी होती है।
            जल्दी डिलीवरी और रिटर्न चाहिए? हमारी रिटेल दुकान चुनें।
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowNote(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Row className="justify-content-center mt-4">
        <Col md={10}>
          <div className="shop-profile-card p-1 shadow-lg rounded d-flex align-items-center">
            <div className="shop-image-container">
              {shopDetails ? (
                <Image
                  src={`https://yaasaai.com/ShopImages/${shopDetails.shop_image}`}
                  className="shop-image Imgsetting"
                  alt={shopDetails.shop_name}
                />
              ) : (
                <p>Loading image...</p>
              )}
            </div>
            <div className="shop-details ms-4">
              {shopDetails && (
                <>
                  <h1 className="fw-bold text-success">
                    {shopDetails.shop_name}
                  </h1>
                  <h4 className="text-muted">{shopDetails.shop_address}</h4>
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <h2 className="h2head">All Offers Available at this Shop</h2>
        </Col>
      </Row>

      <Row className="gx-3">
        {vegetables.length > 0 ? (
          vegetables.map((veg) => {
            const totalStock = parseInt(veg.offer_stock) || 0;
            const addedStock = parseInt(veg.offer_stock_added) || 0;

            return (
              <Col xs={12} key={veg.id} className="mb-4">
                <Card className="h-100 shadow-sm w-100 p-3">
                  <Row className="align-items-left">
                    <Card.Title className="offer_title fs-5 mb-2 bg-dark">
                      {veg.veg_name}
                    </Card.Title>
                    <Col md={6} xs={5} className="text-center mb-5 mb-md-0">
                      <Card.Img
                        src={`https://yaasaai.com/vegetableimages/${veg.veg_image_name}`}
                        alt={veg.veg_name}
                        className="img-fluid rounded"
                        style={{
                          maxHeight: "200px",
                          objectFit: "contain",
                          width: "100%",
                        }}
                      />
                    </Col>

                    <Col md={6} xs={7}>
                      <Card.Body className="p-0 ps-md-3">
                        <div className="offercard_text mb-0">
                          {/*<div>
                            <strong>Quantity Type:</strong> {veg.qty_type}
                          </div>
                          <div>
                            <strong>Offer Description:</strong> {veg.offer_des}
                          </div>*/}
                          <div>
                            <strong>Original Price:</strong> ₹{veg.total_price}
                          </div>
                          {/*<div>
                            <strong>Market Price:</strong>{" "}
                            <span className="text-danger">
                              ₹{veg.market_price}
                            </span>
                          </div>*/}
                          <div>
                            <strong>Item Details:</strong>
                            <pre
                              style={{
                                whiteSpace: "pre-wrap",
                                fontSize: "11px",
                                marginBottom: 0,
                                textTransform: "capitalize",
                              }}
                            >
                              {veg.item_details}
                            </pre>
                          </div>
                        </div>

                        {totalStock > 0 && (
                          <div className="mt-3">
                            <strong>Slots Filled:</strong>
                            <div className="d-flex flex-wrap gap-1 mt-1">
                              {Array.from({ length: totalStock }).map(
                                (_, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      backgroundColor:
                                        index < addedStock ? "#28a745" : "#ccc",
                                      borderRadius: "4px",
                                    }}
                                    title={`Slot ${index + 1}`}
                                  ></div>
                                )
                              )}
                            </div>
                            <small className="text-muted">
                              {addedStock} of {totalStock} slots filled
                            </small>
                          </div>
                        )}

                        <Button
                          variant="success"
                          className="mt-md-4"
                          onClick={() => handleAddToCart(veg)}
                          style={{ minWidth: "150px", marginLeft: "0px" }}
                        >
                          Add to Cart
                        </Button>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            );
          })
        ) : (
          <p>No offers available at this shop.</p>
        )}
      </Row>
    </Container>
  );
};

export default OfferShopProfile;
